import { Component, Input, Output, EventEmitter,OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
    selector: 'core-layout-modal-message-one-action',
    templateUrl: './modal-message-one-action.component.html',
    styleUrls: ['./modal-message-one-action.component.scss']
})
export class LayoutModalMessageOneActionComponent implements OnInit {
    // public textControl = new FormControl('');
    public buttonEnabled: boolean = false;
    public message: string = '';
    public lengthLimit: number = 6000; // the length of allowed message string including html
    public limitReached: boolean = false;
    @Input() title: string;
    @Input() text: string;
    @Input() messagePlaceholder: string = 'Write your message...';
    @Input() buttonText: string;
    @Input() buttonType: string = '';
    @Input() disabled: boolean = false;
    @Input() emojis: boolean = false;

    @Output() buttonClick = new EventEmitter<string>();
    @Output() buttonCloseClick = new EventEmitter<string>();

    ngOnInit() {
        // this.textControl.valueChanges.subscribe(value => {
        //     this.buttonEnabled = true;
        //     if(value.trim() == '')
        //         this.buttonEnabled = false;
        //     else {
        //         this.message = value;
        //     }
        // });
    }

    onButtonClick(e) {
        this.buttonClick.emit(this.message);
    }

    onButtonCloseClick(e){
        this.buttonCloseClick.emit(this.message);
    }

    onMessageChange(msgData: WysiwygData){
        // Here we update current FormControl to set value to save with the form.
        

        this.buttonEnabled = true;
        this.limitReached = false;
        if(msgData.text.trim() == ''){
            this.buttonEnabled = false;
        } else if(msgData.html.length > this.lengthLimit){ 
            // display a meesage warning to notify content length
            this.buttonEnabled = false;
            this.limitReached = true;
        }
        else {
            this.message = msgData.html; // need to be updated to send to save message
        }

    }
}
